<template>
 <div class="container">
    <div class="filter">
        <el-row>
            <el-col :span="24">
                <el-input class="w160 mr4" placeholder="請輸入樓盤編號" v-model="propertyId"  @input="checkInt('propertyId')"></el-input>
                <el-select class="w160 mr4" filterable remote v-model="accountName" :remote-method="(query)=>{remoteMethods(query,'accountName')}"  @visible-change="clearNo" placeholder="請輸入放盤人姓名" clearable>
                    <el-option v-for="item in accountNameOptions" :key="item.index" :label="item.accountName" :value="item.accountName" />
                </el-select>
                <el-select class="w160 mr4" filterable remote v-model="createUser" :remote-method="(query)=>{remoteMethods(query,'createUser')}"  @visible-change="clearNo" placeholder="請輸入操作人姓名" clearable>
                    <el-option v-for="item in nameOptions" :key="item.index" :label="item.createUser" :value="item.createUser" />
                </el-select>
                <el-date-picker format="yyyy/MM/dd" value-format="timestamp" class="w150 mr4" v-model="startTime" type="date" :picker-options="startTimeOption" placeholder="選擇日期"></el-date-picker>—
                <el-date-picker format="yyyy/MM/dd" value-format="timestamp" class="w150 mr4" v-model="endTime" :picker-options="endTimeOption" type="date" placeholder="選擇日期"></el-date-picker>
               
                <span class="btn-filter">
                    <el-button type="danger" class="seabtn" @click="clickSearch">查詢</el-button>
                    <el-button type="info" @click="resetSearch">重置</el-button>
                </span>
            </el-col>
        </el-row>
    </div>
    <div class="table_container">
        <el-table :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }" :data="tableData" style="width: 100%" v-loading="listLoading" fit>
            <el-table-column prop="propertyId" label="樓盤編號">
                <template slot-scope="scope">
                    <span class="span" @click="enterDetails(scope.row.rentalType, scope.row.propertyId)">{{ scope.row.propertyId }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="修改日誌" min-width="150"></el-table-column>
            <el-table-column prop="accountName" label="放盤人"></el-table-column>
            <el-table-column prop="createUser" label="操作人"></el-table-column>
            <el-table-column prop="createTime" label="操作時間">
                <template slot-scope="scope">
                    <p>{{scope.row.createTime | getNewTime}}</p>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <span :class="['span', { disspan: scope.row.operationType != 'Edit' && scope.row.operationType != 'Add'}]" @click='goJournalPro(scope.row)'>詳情</span>
                </template>
            </el-table-column>
        </el-table>
        <pagination class="bottom-right" :total="total" :page.sync="pageIndex" :limit.sync="pageCount" @pagination="loadJournalList" />
    </div>
 </div>
</template>

<script>
import Pagination from '@/components/Pagination';

export default {
 data() {
  return {
    propertyId: '',
    createUser: '',
    accountName:'',
    operationType: '',
    startTime: '',
    endTime: '',
    pageIndex: 1,
    pageCount: 20,
    listLoading:false,
    startTimeOption: {
        disabledDate: this.startTimeOption1
    },
    endTimeOption: {
        disabledDate: this.endTimeOption1
    },
    nameOptions:[],
    accountNameOptions:[],
    tableData: [],
    total: 0,
    checkIntNum:'',
  }
 },
 created(){
    this.propertyId = this.$route.query.propertyId
    this.loadJournalList();
 },
 methods:{
    enterDetails(type, id) {

        let url = `${this.pub.config.pcUrl}${type === 1 ? 'buy' : 'rent'}-property-${id}/`;
        window.open(url);
    },
    checkInt(data){
        /^$|^\d{0,20}$/.test(this[data]) ? (this.checkIntNum = this[data]) : (this[data] = this.checkIntNum);
    },
    goJournalPro(row){
        if(row.operationType != 'Edit' && row.operationType != 'Add')return
        // /property/journalProperty
        const {href} = this.$router.resolve({
            name:this.pub.routeNameLists.JournalProperty,
            query: {
                propertyId: row.propertyId,
                operationID:row.operationID
            }
        })
        window.open(href, '_blank');
        // this.$router.push({
        //     name: this.pub.routeNameLists.JournalProperty,
        //     params: {
        //         propertyId: row.propertyId,
        //         operationID:row.operationID
        //     }
        // });
    },
    getSearchValue() {
            const data = {};
            data.pageIndex = this.pageIndex;
            data.pageCount = this.pageCount;
            if (this.propertyId) data.propertyId = this.propertyId;
            if (this.accountName) data.accountName = this.accountName;
            if (this.createUser) data.createUser = this.createUser;
            if (this.startTime) data.startTime = this.startTime / 1000;
            if (this.endTime) data.endTime = this.endTime / 1000 + 24 * 60 * 60;
            return data;
        },
    startTimeOption1(time) {
            if (this.endTime) {
                return time.getTime() > this.endTime || time.getTime() < (new Date()).getTime()-365*2*24*3600*1000;
            } else {
                return time.getTime() < (new Date()).getTime()-365*2*24*3600*1000;
            }
        },
        endTimeOption1(time) {
            if (this.startTime) {
                return time.getTime() < this.startTime;
            } else {
                return time.getTime() < (new Date()).getTime()-365*2*24*3600*1000;
            }
        },
    clickSearch(){
        this.pageIndex = 1;
        this.loadJournalList();
    },
    resetSearch(){
        this.propertyId = '',
        this.createUser = '',
        this.accountName = '',
        this.startTime = '',
        this.endTime = '',
        this.clickSearch();

    },
    loadJournalList(){
        this.listLoading = true;
        const data = this.getSearchValue();
        this.axios.post(this.pub.getApi().SearchPropertyOperationLog, data).then(res => {
            if (res.data.code == 0) {
                this.tableData = res.data.result.data;
                this.total = res.data.result.count;
                this.listLoading = false;
                let main = document.querySelector('.el-main');
                main.scroll({
                top: 0,
                left: 0,
                });
            }else{
                this.$message({
                    showClose: true,
                    message: '接口400',
                    type: 'warning'
                });
                this.listLoading = false;
            }
        });
    },
    unique(arr,type) {
            let nameArr = type == 'createUser' ? 'nameOptions':'accountNameOptions'
            let obj = {};
            let peon = arr.reduce((cur, next) => {
                obj[next[type]] ? "" : obj[next[type]] = true && cur.push(next);
                return cur;
            }, [])
            this[nameArr] = peon
        },
    clearNo(visible){
        if(!visible){
            this.accountNameOptions =[]
            this.nameOptions = [];
        }
    },
    getStaffOptions(query,type){
            let nameArr = type == 'createUser' ? 'nameOptions':'accountNameOptions'
            let data = {}
            if(type == 'createUser'){
                data = {
                    pageIndex:1,
                    pageCount:100,
                    createUser:query
                }
            }else{
                data = {
                    pageIndex:1,
                    pageCount:100,
                    accountName:query
                }
            }
            
            this.axios.post(this.pub.getApi().SearchPropertyOperationLog, data).then(res => {
                let recArr = []
                if (res.data.code === 0) {
                    for (var i in res.data.result.data) {
                        if (res.data.result.data[i][type] !== null && res.data.result.data[i][type] !== undefined && res.data.result.data[i][type] !== '') {
                            recArr.push(res.data.result.data[i]);
                        }
                    }
                    this.unique(recArr,type)
                } else {
                    this[nameArr]=[]
                }
                return this[nameArr]
            });
        },
    remoteMethods(query,type) {
            let nameArr = type == 'createUser' ? 'nameOptions':'accountNameOptions'
       		if (query !== "") {
                return this.getStaffOptions(query,type);
            } else {
                this[nameArr]=[]
            }
        },
 },
 components: { Pagination }
}
</script>

<style scoped lang="less">
    .filter{
        /deep/.el-input__inner {
            border-radius: 10px;
            border: none;
            color: #000;
        }
    }
    .w380{
        width:380px;
    }
    .w150{
        width:150px;
    }
    .w160{
        width:160px;
    }
    .mr4{
        margin-right:15px;
    }
    .filter{
        text-align:left;
        margin-bottom:20px;
        .btn-filter{
            button{
                border-radius: 10px;
                width: 88px;
                height: 38px;
            }
            &.seabtn {
                background-color: #E50113 ;
            }
        }
    }
    .table_container{
        padding: 20px;
        border-radius: 20px;
        background-color: #fff;
        .disspan{
            color:#666
        }
        span{
            cursor: pointer;
            color:#0062ff;
        }
    }
</style>
